import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { DeliveryGateway } from 'src/app/application/gateway/DeliveryGateway';
import { ProfileGateway } from 'src/app/application/gateway/ProfileGateway';
import { Importer } from 'src/app/domain/models/Profile';
import { BasicUser } from 'src/app/domain/models/User';
import { excelUtils } from 'src/app/ui/util/excel-utils';
import { formatUrl } from 'src/app/ui/util/file-formats';

@Component({
  selector: 'app-admin-uploads-delivery',
  templateUrl: './admin-uploads-delivery.component.html',
  styleUrls: ['./admin-uploads-delivery.component.css'],

})
export class AdminUploadsDeliveryComponent implements OnInit {

    importers: Importer[] = []
    loading: boolean = false;
    profile: BasicUser | undefined
    uploadFile: any[] = []
    uploadDisabled: boolean = true
    uploadFormatUrl: string = formatUrl.massive_pre_bl_format
    loadingOrderDownload: boolean = false;
    enableDownloadOrderButton: boolean = false;

    form: FormGroup = this._formBuilder.group({
      importerId:[null, Validators.required]
    })

    constructor(
      private _messageService: MessageService,
      private _profileService: ProfileGateway,
      public translate: TranslateService,
      private _deliveryService: DeliveryGateway,
      private _formBuilder: FormBuilder,
      private _authService: AuthGateway,
    )
    {
    }

    ngOnInit(): void {
      this.profile = this._authService.getUser()
      this.getImporters()
    }

    getImporters() {
      this.importers = []
      this.loading = true
      if(this.profile) {
        this._profileService.getAllImporters().subscribe({
          next: (v) => {
            this.importers = v
            this.loading = false
          },
          error: (e) => {
            console.log(e)
            this.loading = false
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail: this.translate.instant('MessageService.Importer.ManyRetrieveError') })
          },
          complete: () => console.info('Importers query successfully')
        })
      }
    }

    sendFiles() {
      this.loading = true
      if (this.uploadFile[0]) {
        const request: any = {
          file: this.uploadFile[0],
          importerId: this.form.controls['importerId'].value
        }

        this._deliveryService.uploadPreBl(request).subscribe({
          next: (v) => {
            this._messageService.add({ severity: 'success',
              summary: this.translate.instant('MessageService.Summary.SuccessAction'),
              detail: 'Pre-Bl cargado exitosamente' })
              this.loading = false
          },
          error: (e) => {
            this.loading = false
            let errorMessage = ''
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail: 'Error al leer archivo' })
          },
          complete: () => console.info('Program request created successfully')
        })
      }else{

        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.FailFileAction')
         })
        this.loading = false
      }
    }

    onSelect(event: any, uploader: any){
      this.uploadFile = uploader.files
      if(this.uploadFile.length > 0){
        this.uploadDisabled = false;
      }else{
        this.uploadDisabled = true;
      }
    }

    onRemove(event: any, uploader: any) {
      this.uploadFile = uploader.files
      if(this.uploadFile.length > 0){
        this.uploadDisabled = false;
      }else{
        this.uploadDisabled = true;
      }
    }

    onClear(event: any, uploader: any) {
      this.uploadFile = uploader.files
      if(this.uploadFile.length > 0){
        this.uploadDisabled = false;
      }else{
        this.uploadDisabled = true;
      }
    }

    downloadPendingOrderFormat(){
      if(this.form.controls['importerId'].value)
        {
        this.loadingOrderDownload = true
        this._deliveryService.downloadPendingOrderFormat(this.form.controls['importerId'].value).subscribe({
          next: (resultBlob) => {
            const contentDisposition = resultBlob.headers.get('content-disposition');
            let nombreArchivo = 'pending_order_format_';

            if (contentDisposition) {
              const match = contentDisposition.match(/filename=([^]+);/);
              if (match && match[1]) {
                  nombreArchivo += match[1];
              }
            }

            excelUtils.downloadExcel(resultBlob.body, nombreArchivo);
              this.loadingOrderDownload = false
          },
          error: (e) => {
            this.loadingOrderDownload = false
            let errorMessage = ''
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail: 'Error al descargar archivo' })
          },
          complete: () => console.info('Program request created successfully')
        })
      }
    }

    onChangeImporterId(){
      if(this.form.controls['importerId'].value){
        this.enableDownloadOrderButton = true;
      }else{
        this.enableDownloadOrderButton = false;
      }
    }

}
